import React from "react";
import PropTypes from "prop-types";
import toastr from "toastr";

const Button = ({
    id,
    label,
    type,
    href,
    loadingLabel,
    className,
    other,
    icon,
    iconPosition,
    disabled,
    loading,
    success,
    successMessage,
    fail,
    failMessage,
    onClick,
    target
}) => {
    const fontDisplay = {
        display: "inline-flex",
        marginLeft: "0.5rem"
    };

    const ButtonTag = href ? "a" : "button";

    if(success){
        toastr.success(successMessage, "Success", {preventDuplicates: true});
    } else if (fail){
        toastr.error(failMessage, "An Issue Occurred", {preventDuplicates: true});
    }

    return(
        <ButtonTag
            id={id}
            href={href}
            target={target}
            className={`${className} ${disabled && "disabled"}`}
            onClick={onClick}
            type={type}
            {...other}
        >

            {icon && iconPosition == "left" && (
                <i className={`${icon}`}></i>
            )}
            {loading ? (
                loadingLabel
            ) : (
                label
            )}

            {icon && iconPosition == "right" && (
                <i className={`${icon}`}></i>
            )}

            {loading && (
                <div style={fontDisplay}>
                    <i className="fas fa-spinner-third fa-spin"></i>
                </div>
            )}
        </ButtonTag>
    );
};

Button.defaultProps = {
    id: "",
    label: " ",
    href: "",
    loadingLabel: "...",
    className: "btn btn-lx",
    icon: "",
    iconPosition: "left",
    type: "",
    disabled: false,
    loading: false,
    success: false,
    successMessage: "Success!",
    fail: false,
    failMessage: "Something has gone horribly wrong",
    other: {},
    onClick: (()=>{}),
    target: "_self"
};

Button.propTypes = {
    id: PropTypes.string,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    type: PropTypes.string,
    href: PropTypes.string,
    loadingLabel: PropTypes.string,
    className: PropTypes.string,
    other: PropTypes.object,
    icon: PropTypes.string,
    iconPosition: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    success: PropTypes.bool,
    successMessage: PropTypes.string,
    fail: PropTypes.bool,
    failMessage: PropTypes.string,
    onClick: PropTypes.func,
    target: PropTypes.string
};

export default Button;